<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
@if (isScreenSmall || isScreenMedium) {
    <fuse-vertical-navigation
        class="dark bg-gray-900 print:hidden"
        [mode]="'over'"
        [name]="'mainNavigation'"
        [navigation]="navigation.horizontal"
        [opened]="false"
    >
        <!-- Navigation header hook -->
        <ng-container fuseVerticalNavigationContentHeader>
            <!-- Logo -->
            <div class="flex h-20 items-center px-8 pt-6">
                <img
                    class="w-24"
                    src="images/logo/logo-text-on-dark.svg"
                    alt="Logo image"
                />
            </div>
        </ng-container>
    </fuse-vertical-navigation>
}

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
    <!-- Payment failed banner — shown above all when subscription is PAYMENT_INCOMPLETE (PIN) -->
    <payment-failed-banner></payment-failed-banner>

    <!-- Plan limit top bar — above header -->
    <plan-limit-top-bar></plan-limit-top-bar>

    <!-- Header -->
    @if (!inOptimizedMode) {
        <div
            class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none md:px-6 print:hidden"
        >
            <!-- Logo - Always visible -->
            <div class="flex items-center lg:mr-8">
                <div class="hidden lg:flex">
                    <img
                        class="w-32 dark:hidden cursor-pointer"
                        src="images/logo/logo-text.svg"
                        (click)="onLogoClick()"
                        alt="Logo"
                    />
                    <img
                        class="hidden w-32 dark:flex cursor-pointer"
                        src="images/logo/logo-text-on-dark.svg"
                        (click)="onLogoClick()"
                        alt="Logo"
                    />
                </div>
                <img
                    class="flex w-8 lg:hidden"
                    src="images/logo/logo.svg"
                    (click)="onLogoClick()"
                    alt="Logo"
                />
            </div>

            <!-- Navigation toggle button - mobile only, team/affiliate users (not partners) -->
            @if (isScreenSmall && user && !isPartnerUser) {
                <button
                    class="ml-2"
                    mat-icon-button
                    (click)="toggleNavigation('mainNavigation')"
                >
                    <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                </button>
            }

            @if (!isScreenSmall) {
                <!-- Centered horizontal navigation -->
                <div class="flex-1 flex justify-center">
                    <fuse-horizontal-navigation
                        class="mx-auto"
                        [name]="'mainNavigation'"
                        [navigation]="navigation.horizontal"
                    ></fuse-horizontal-navigation>
                </div>
            }

            <!-- Components -->
            <div class="flex items-center space-x-0.5 pl-2 sm:space-x-2" [class.ml-auto]="isScreenSmall || isScreenMedium" [class.sm:ml-0]="!isScreenSmall && !isScreenMedium">
                <trial-period [subscription]="subscription"></trial-period>
                @if (showUpgradeButton) {
                    <button
                        class="inline-flex items-center mr-2 h-8 px-3 text-sm font-medium rounded-full border border-gray-300 bg-white text-gray-800 hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
                        matTooltip="{{ 'common.buttons.upgrade' | transloco }}"
                        (click)="navigateToUpgrade()">
                        <mat-icon class="icon-size-4 mr-1">arrow_circle_up</mat-icon>
                        <span class="hidden sm:inline">{{ 'common.buttons.upgrade' | transloco }}</span>
                    </button>
                }
                <languages></languages>
                <establishment-switcher></establishment-switcher>
                <user [showAvatar]="false"></user>
                <!-- <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
                <search [appearance]="'bar'"></search>
                <shortcuts></shortcuts>
                <messages></shortcuts>
                <notifications></notifications>
                <button
                    class="lg:hidden"
                    mat-icon-button
                    (click)="quickChat.toggle()"
                >
                    <mat-icon
                        [svgIcon]="'heroicons_outline:chat-bubble-left-right'"
                    ></mat-icon> -->
            </div>
        </div>
    }
    
    <!-- Content -->
    <div class="flex w-full flex-auto flex-col" [class.pb-20]="isScreenSmall && isPartnerUser && !inOptimizedMode">
        <!-- Impersonation banner -->
        <impersonation-banner></impersonation-banner>


        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
            <router-outlet></router-outlet>
        }
    </div>

    <!-- Footer -->
    <!-- <div
        class="bg-card relative z-49 flex h-14 w-full flex-0 items-center border-t px-4 dark:bg-transparent sm:h-20 md:px-6 print:hidden"
    >
        <span class="text-secondary font-medium"
            >Fuse &copy; {{ currentYear }}</span
        >
    </div> -->
</div>

<!-- Bottom Navigation - Mobile Only, partner users (not tablet) -->
@if (isScreenSmall && isPartnerUser && !inOptimizedMode) {
    <bottom-navigation [navigation]="bottomNavItems"></bottom-navigation>
}

<!-- Quick chat -->
<!-- <quick-chat #quickChat="quickChat"></quick-chat> -->
